(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/campaign-step/assets/javascripts/campaign-step.js') >= 0) return;  svs.modules.push('/components/lb-ui/campaign-step/assets/javascripts/campaign-step.js');
"use strict";


const _svs$ui$ReactStepIndi = svs.ui.ReactStepIndicator,
  StepIndicator = _svs$ui$ReactStepIndi.StepIndicator,
  Step = _svs$ui$ReactStepIndi.Step;
const defaultSteps = ['Bli kund', 'Sätt in', 'Spela', 'Få bonus'];
const CampaignStep = _ref => {
  let _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? defaultSteps : _ref$steps,
    currentStepIndex = _ref.currentStepIndex,
    branding = _ref.branding;
  return React.createElement("div", {
    className: "campaign-step"
  }, React.createElement(StepIndicator, {
    block: false,
    branding: branding,
    isClosed: true
  }, steps.map((step, i) => React.createElement(Step, {
    isSelected: currentStepIndex >= i,
    key: step
  }, step))));
};
setGlobal('svs.components.lbUi.campaignStep.CampaignStep', CampaignStep);

 })(window);